
import BRadioButton from 'JS/components/blain-form/BRadioButton.vue';
import { computed, defineComponent, toRef } from 'vue';
import { IAdditionalServiceOptionResource } from 'JS/automotive/auto-service-scheduler/types/session';
import { PropType } from 'vue';
import { useBreakpoints } from 'JS/composables/breakpoint';

export default defineComponent({
	name: 'AutoServiceRadioButton',
	components: {
		BRadioButton
	},
	props: {
		service: {
			type: Object as PropType<IAdditionalServiceOptionResource>,
			required: true,
		},
		selectedService: {
			type: String,
			required: true,
		},
	},
	emits: ['radioSelected'],
	setup(props) {
		const service = toRef(props, 'service');
		const selectedService = toRef(props, 'selectedService');
		const selected = computed(() => selectedService.value === service.value.blainNumber);
		const arialabel = computed(() => service.value.name.replace(' ', '-') + "optioninfo");
		const { isMobile } = useBreakpoints();

		return {
			selected,
			arialabel,
			isMobile
		};
	}
});
